/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdTagInputProps } from './type';

export const tagInputDefaultProps: TdTagInputProps = {
  autoWidth: false,
  borderless: false,
  clearable: false,
  dragSort: false,
  excessTagsDisplayType: 'break-line',
  defaultInputValue: '',
  minCollapsedNum: 0,
  placeholder: undefined,
  readonly: false,
  readOnly: false,
  size: 'medium',
  defaultValue: [],
};
